import React from 'react';
import { Icon, IconTypes } from '@eika/icon';
import { ErrorLabel } from '@eika/label';
import '@eika/button-style/src/AccountSelectorLayout.scss';

export interface AccountSelectorLayoutProps {
    placeholder?: string;
    label?: string;
    extraLabel?: React.ReactNode;
    accountAlias?: string;
    accountNumber?: string;
    amount?: string;
    error?: string;
    /** override label with a custom label */
    customLabel?: JSX.Element;
    /** IconTypes | <Icon .../> */
    icon?: IconTypes | ReturnType<typeof Icon>;
    credit?: string;
}

const AccountSelectorLayout = ({
    placeholder = '',
    label,
    extraLabel,
    accountAlias,
    accountNumber,
    amount,
    error,
    customLabel,
    icon,
    credit,
}: AccountSelectorLayoutProps): JSX.Element => {
    const renderContent = () => {
        if (error) {
            return (
                <span className="account-selector-layout__left-single-value" role="alert">
                    <ErrorLabel className="account-selector-layout__error-label" text={error} />
                </span>
            );
        }
        if (accountNumber || accountAlias || amount) {
            return (
                <>
                    <span className="account-selector-layout__first-row">
                        <span className="account-selector-layout__label">{label}</span>
                        <span className="account-selector-layout__extra-label">{extraLabel}</span>
                    </span>
                    <span className="account-selector-layout__second-row">
                        <span className="account-selector-layout__alias">{accountAlias}</span>
                        <span className="account-selector-layout__value">{amount}</span>
                    </span>
                    <span className="account-selector-layout__third-row">
                        <span className="account-selector-layout__account-number">{accountNumber}</span>
                        <span className="account-selector-layout__credit">{credit}</span>
                    </span>
                </>
            );
        }
        if (customLabel) {
            return <span className="account-selector-layout__left-single-value">{customLabel}</span>;
        }
        return (
            <span className="account-selector-layout__left-single-value account-selector-layout__placeholder">
                {placeholder}
            </span>
        );
    };

    const isReactElement = (icon: IconTypes | ReturnType<typeof Icon>): icon is ReturnType<typeof Icon> =>
        React.isValidElement(icon);

    const renderIcon = (icon: IconTypes | ReturnType<typeof Icon>) =>
        isReactElement(icon) ? icon : <Icon type={icon as IconTypes} className="icon--20" />;

    return (
        <div className="account-selector-layout__container">
            {renderContent()}
            {icon && <div className="account-selector-layout__icon">{renderIcon(icon)}</div>}
        </div>
    );
};

export default AccountSelectorLayout;
